<template>
    <router-link :to="route.path" v-if="isPermitted" class="sidebar-menu-item">
        <div :class="route.meta.icon"></div>
        <span>{{ route.meta.name }}</span>
    </router-link>
    
</template>


<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import store from '../store'
import { dashboard_routes } from '../routes'

export default {
    data () {
        return {
        }
    },
    props:{
        route: {}
    },

    computed : {
        isPermitted: function(){
            let perm = this.route.meta.requiresPerm;
            if (this.route.meta.name === "Users"){
                // Also ensuring that user is an admin
		let isAdmin = store.state.userGroups.some(function(group){
		    return group.name === "Administrator";
		})
		if (!isAdmin){
                    return false;
                }
            }
            return store.getters.hasPerm(perm);
            
        },
    },
}

</script>



// WEBPACK FOOTER //
// src/components/SidebarLink.vue